var _rect, _circle, _path, _rect2, _rect3, _circle2, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccountInfoH(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9,
    width: 35,
    height: 21.3889,
    rx: 3,
    fill: "#53E3AC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 17,
    r: 2.5,
    fill: "#D0FFED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20.5C7.51472 20.5 5.5 22.3775 5.5 24.6935C5.5 24.8302 5.50702 24.9654 5.52073 25.0987C5.54496 25.3342 5.75271 25.5 5.98942 25.5H14.0106C14.2473 25.5 14.455 25.3342 14.4793 25.0987C14.493 24.9654 14.5 24.8302 14.5 24.6935C14.5 22.3775 12.4853 20.5 10 20.5Z",
    fill: "#D0FFED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2998,
    y: 15.58,
    width: 14,
    height: 2.6,
    rx: 1.3,
    fill: "#D0FFED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.2998,
    y: 20.6799,
    width: 9,
    height: 2.6,
    rx: 1.3,
    fill: "#D0FFED"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.7998,
    cy: 29.5,
    r: 6.5,
    fill: "#1290FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5498 29.4999H36.0498",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7998 26.25L32.7998 32.75",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountInfoH);
export default __webpack_public_path__ + "static/media/icon_account_info_h.a769d946.svg";
export { ForwardRef as ReactComponent };